import { apiRequest } from "@/lib/api";
import type { PlanApi } from "@/types/plan";

export async function getPlans(): Promise<PlanApi[]> {
  return apiRequest<PlanApi[]>("/plans/", {
    method: "GET",
  });
}

export async function getPlan(
  slug: string,
): Promise<PlanApi> {
  return apiRequest<PlanApi>(
    `/plans/${encodeURIComponent(slug)}/`,
    {
      method: "GET",
    },
  );
}

export function formatPlanPrice(
  value: string | null,
): string {
  if (value === null) return "Em definição";
  const price = Number(value);

  if (!Number.isFinite(price)) {
    return "R$ 0";
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits:
      Number.isInteger(price) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(price);
}
